import { initPromoBanner } from '../../../snippets/promo-banner/promo-banner';

export const initPromoBannerHero = () => {
  initPromoBanner('promo-banner-hero');

  return true;
};
